import { Link } from 'react-router-dom';

const riskItems = [
  {
    icon: 'ri-scales-3-line',
    title: '刑事法律责任',
    desc: '传播淫秽物品最高可判处无期徒刑，了解法律红线，远离违法犯罪。',
    bgClass: 'bg-primary-50',
    iconClass: 'text-primary-600',
    borderClass: 'border-primary-200/60',
  },
  {
    icon: 'ri-shield-flash-line',
    title: '平台永久封禁',
    desc: '微信、抖音等平台对违规内容零容忍，一经发现账号将被永久关闭。',
    bgClass: 'bg-accent-50',
    iconClass: 'text-accent-600',
    borderClass: 'border-accent-200/60',
  },
  {
    icon: 'ri-lock-line',
    title: '隐私数据泄露',
    desc: '非法App窃取通讯录、相册等敏感信息，可能导致勒索和精准诈骗。',
    bgClass: 'bg-secondary-50',
    iconClass: 'text-secondary-600',
    borderClass: 'border-secondary-200/60',
  },
  {
    icon: 'ri-mental-health-line',
    title: '青少年心理危害',
    desc: '长期接触不良内容将严重影响青少年大脑发育和价值观念形成。',
    bgClass: 'bg-primary-50',
    iconClass: 'text-primary-600',
    borderClass: 'border-primary-200/60',
  },
];

export default function RiskCards() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            <strong>茄子视频污</strong>的四大危害
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            使用和传播不良视频内容可能面临法律制裁、隐私泄露、账号封禁等多重风险，每一个都足以毁掉你的正常生活。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {riskItems.map((item) => (
            <div
              key={item.title}
              className={`${item.bgClass} border ${item.borderClass} rounded-xl p-6 transition-transform duration-300 hover:-translate-y-1`}
            >
              <div className={`w-12 h-12 rounded-xl ${item.bgClass} flex items-center justify-center mb-4`}>
                <i className={`${item.icon} text-2xl ${item.iconClass}`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-900 text-base mb-2">{item.title}</h3>
              <p className="text-foreground-600 text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/risk-warning"
            className="inline-flex items-center gap-1.5 text-accent-600 hover:text-accent-700 font-medium text-sm transition-colors cursor-pointer"
          >
            了解更多风险警示
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}